import { render, staticRenderFns } from "./SignatureTab.vue?vue&type=template&id=25413e0c&scoped=true"
import script from "./SignatureTab.vue?vue&type=script&lang=js"
export * from "./SignatureTab.vue?vue&type=script&lang=js"
import style0 from "./SignatureTab.vue?vue&type=style&index=0&id=25413e0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25413e0c",
  null
  
)

export default component.exports